export default {
  apiUrlV1: process.env.ESENTAI_API,
  apiUrlV2: process.env.ESENTAI_API_V2,
  appUrl: process.env.APP_URL,
};
